<template>
  <div class="Dashboard ">

    <div class="row mt-3">
      <div class="col-sm-6">
        <router-link to="/add-student"
          ><div class="card count-card">
            <p class="fs-2">Total Students</p>
            <p class="fs-1 fw-semibold">{{ StudentCount }}</p>
          </div>
        </router-link>
      </div>
      <div class="col-sm-6">
                <router-link to="/add-assignment">
          <div class="card count-card">
            <p class="fs-2">Assignments Added </p>
            <p class="fs-1 fw-semibold">{{ AssignmentCount }}</p>
          </div>
                </router-link>
      </div>
    </div>
  <router-link to="/add-assignment">
      <div class="row mt-4">
        <div class="card count-card">
          <p class="fs-2 fw-semibold">Last Assignment Added</p>
          <p class="fs-5">Assignment Code: {{LastAssignmentAdded.acode}}</p>
          <p class="fs-5">Assignment Name: {{LastAssignmentAdded.aheading}}</p>
          <p class="fs-5">Assignment Done by students: {{SubmittedDataCount}}</p>

        </div>
      </div>
  </router-link>
            <router-link to="/add-notice">
      <div class="row mt-4">
        <div class="card count-card">
              <p class="h3">Last Notification</p>
          <p class="fs-5">{{LastNotificationAdded.ntitle}}</p>
        </div>
      </div>
            </router-link>
  </div>
</template>

<script>
import axios from 'axios'
import config from "@/config"


export default {
  name: "HomeView",
  components: {},
  data(){
    return{
        students:[],
        StudentCount:"",
        Assignments:[],
        AssignmentCount:"",
        LastAssignmentAdded:"",
        acode:"",
        aheading:"",
        SubmittedData:[],
        SubmittedDataCount:"",
        Ascode:this.acode,
        
            LastNotificationAdded:""
    }
},




methods:{





//Get Students list
        async getStudents() {
      try {
        let {
          data
        } = await axios.get(`${config.apiBaseUrl}/api/users/get-student`)

        this.students = data
        this.StudentCount = data.length
      } catch (error) {
        console.error(error)
      }

    },  
async getAssignments(){
  
    let {
    data
  } = await axios.get(`${config.apiBaseUrl}/api/assignments/get-assignments`)
  
  this.Assignments = data,
  this.AssignmentCount = data.length
this.LastAssignmentAdded = data[data.length-1]


},


// Get Submitted Assignment By Acode
 async getAssignmentsByCode(){

    let acode = this.LastAssignmentAdded.acode
    
let {
    data
}= await axios.get(`${config.apiBaseUrl}/api/submissions/get-students-by-acode?acode=${acode}` )

  this.SubmittedData = data,
this.SubmittedDataCount = data.length




},
// Get notification lists
async getNotifications(){
  
    let {
    data
  } = await axios.get(`${config.apiBaseUrl}/api/notifications/get-notification`)
  this.Notifications = data
  this.LastNotificationAdded = data[data.length-1]

}

// 

},
created(){
  this.getStudents()
  this.getAssignments()
  this.getNotifications()
 

},
beforeUpdate(){
this.getAssignmentsByCode()
}

};
</script>

<style >
  #app{
    font-family: Raleway, Avenir, Helvetica, Arial, sans-serif;
    }
.count-card {
  background:linear-gradient(127deg, #275395 0%, rgb(22 135 156) 100%);
  padding: 10px 0px 0px 30px;
  height: fit-content;
  color: white;
}

 a{
  text-decoration: none!important;
}



</style>